import axios from 'axios';
import { validateBr } from 'js-brasil';
import {useEffect, useState} from 'react';

const { detect } = require('detect-browser');
const browserDetect = detect();

const { validarCNPJAlfaNumerico } = require('./validaCpfCnpj.js');

export async function getAsyncDadosConfig() {
  let ret = await axios.get('config.json');
  return ret;
}

export function arrayMove(arr, old_index, new_index) {
  while (old_index < 0) {
    old_index += arr.length;
  }
  while (new_index < 0) {
    new_index += arr.length;
  }
  if (new_index >= arr.length) {
    var k = new_index - arr.length;
    while (k-- + 1) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

export function removeValueFromArray(value, array) {
  var index = array.indexOf(value);
  while (index > -1) {
    array.splice(index, 1);
    index = array.indexOf(value);
  }
  return array;
}

export function removeElementFromArray(myObjects, prop, valu) {
  return myObjects.filter(function (val) {
    return val[prop] !== valu;
  });
}

export function returnObjectToArray(object) {
  let objArrayOriginal = [];
  let objArrayFinal = [];
  // eslint-disable-next-line
  for (let key in object) {
    objArrayOriginal.push(Object.values(object[key]));
    objArrayFinal.push(Object.keys(object[key]));
  }
  return [objArrayFinal, objArrayOriginal];
}

export async function getConfigAll() {
  const config = await axios('config.json');
  return config.data;
}
export async function getConfig(param) {
  let config = await axios('config.json');
  let ret = config.data;

  if (param && param !== 'notificacao') {
    ret = config.data[param];
    ret.idAplicacao = config?.data?.idAplicacao;
    ret.idCliente = config.data?.idCliente;
    ret.socketToken = config.data.socketToken;
    ret.service = ret?.service ? ret?.service : '';
    ret.baseUrl =
      ret && ret.server
        ? `${ret.protocol}://${ret.server}:${ret.port}${
            ret.service ? `/${ret.service}` : ''
          }`
        : '';
    ret.idAplicacao = config.data['idAplicacao'];
  }
  return ret;
}

export async function getDadosConfig() {
  return await axios('config.json');
}

export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function contains(arr, valueOrObject) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].substring(0, valueOrObject.length) === valueOrObject) {
      return true;
    }
  }
  return false;
}

export function leftPad(value, totalWidth, paddingChar) {
  var length = totalWidth - value.toString().length + 1;
  return Array(length).join(paddingChar || '0') + value;
}

export function hasProfile(profiles, name) {
  if (Array.isArray(profiles)) {
    let profile = profiles.filter(function (item) {
      return item.name === name;
    });
    if (profile.length > 0) return true;
  }
  return false;
}

export function checkVisibileInViewport(element) {
  var bounding = element.getBoundingClientRect();
  if (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  ) {
    return true;
  } else {
    return false;
  }
}

export function invalidPagePermission(user) {
  if (!user) {
    console.log('obj null');
    return true;
  }
  if (Array.isArray(user.profiles)) {
    let profile = user.profiles.filter(function (item) {
      return item.accessKey === 'editor-regras';
    });
    if (profile.length > 0) return false;
  }
  console.log('nao localizado key');
  return true;
}

export function getUserToken(servico = 'corporate') {
  return sessionStorage.getItem('_nscorporate_user')
    ? JSON.parse(sessionStorage.getItem('_nscorporate_user')).tokens[servico]
    : '';
}

// obter o ip do cliente
export async function getIPs(callback) {
  var RTCPeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection;

  var mediaConstraints = {
    optional: [{ RtpDataChannels: false }],
  };

  var servers = { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] };
  var pc = new RTCPeerConnection(servers, mediaConstraints);

  pc.onicecandidate = (ice) => {
    if (ice.candidate) {
      var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
      var ips = [];
      if (ip_regex.exec(ice.candidate.candidate) !== null) {
        ips.push(ip_regex.exec(ice.candidate.candidate)[0]);
        callback(ips[ips.length - 1]);
      }
    }
  };
  pc.createDataChannel('');
  pc.createOffer(
    function (result) {
      pc.setLocalDescription(
        result,
        function () {},
        function () {}
      );
    },
    function () {}
  );
}

export function detectBrowser() {
  let browser = {};
  if (browserDetect) {
    browser.name = browserDetect.name;
    browser.version = browserDetect.version;
    browser.os = browserDetect.os;
  }
  return browser;
}

export function capitalizeWords(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function validJWTCorporate() {
  var jwt = require('jsonwebtoken');
  var validJWT = true;
  const token = sessionStorage.getItem('_nscorporate_user');
  if (!!token) {
    var decodedToken = jwt.decode(JSON.parse(token).tokens.corporate, {
      complete: true,
    });
    var dateNow = new Date();

    if (new Date(decodedToken.payload.exp * 1000) < dateNow) validJWT = false;
  }
  return validJWT;
}

export function removeSessionItem(servico = '_nscorporate_user') {
  return sessionStorage.removeItem(servico);
}

export function validarCPF(cpf) {
  if (cpf) cpf = cpf.toString().padStart(11, '0');
  let numeros, digitos, soma, i, resultado, digitos_iguais;
  digitos_iguais = 1;
  if (cpf.length !== 11) return false;
  for (let i = 0; i < cpf.length - 1; i++)
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      digitos_iguais = 0;
      break;
    }
  if (!digitos_iguais) {
    numeros = cpf.substring(0, 9);
    digitos = cpf.substring(9);
    soma = 0;
    for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
    resultado = (soma % 11 < 2 ? 0 : 11 - (soma % 11)).toString();
    if (resultado !== digitos.charAt(0)) return false;
    numeros = cpf.substring(0, 10);
    soma = 0;
    for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
    resultado = (soma % 11 < 2 ? 0 : 11 - (soma % 11)).toString();
    if (resultado !== digitos.charAt(1)) return false;
    return true;
  } else return false;
}
export function validarCNPJ(cnpj) {

  return validarCNPJAlfaNumerico(cnpj);

}

export const validaChassi = (val) => {
  if (val && val.toString().length < 17) {
    return false;
  }
  if (val && validateBr.chassi(val)) {
    return true;
  }
  return false;
};

export const validateCpfCnpj = (val) => {
  if (val && (val.length === 14 || val.length === 11) && validateBr.cpf(val)) {
    return true;
  }

  if (val && (val.length === 18 || val.length === 14) && validarCNPJAlfaNumerico(val)) {
    return true;
  }

  return false;
}

export function useCurrentWitdh() {

  const getWidth = () => window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth;

  let [width, setWidth] = useState(getWidth());

  useEffect(() => {
      const resizeListener = () => {
          setWidth(getWidth())
      };

      window.addEventListener('resize', resizeListener);

      return () => { window.removeEventListener('resize', resizeListener); }
  }, [])

  return width;
}

export const findInObject = (obj, pathToValue = '', fallbackReturn = '') =>
    pathToValue
        .split('.')
        .reduce((prevField, currentField) => {
            return prevField && prevField[currentField];
        }, obj) || fallbackReturn;

export const trimPhrase = (phrase, maxLength) => {
    if (phrase.length > maxLength) {
        const trimmedPhrase = phrase.slice(0, maxLength);
        return `${trimmedPhrase}...`;
    }

    return phrase;
}
